import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import {
  AssetAllocatorState,
  GoalData,
  AssetAllocation,
  AssetResponse,
} from './types';
import { watchAssetAllocatorSaga } from './saga';

export const initialState: AssetAllocatorState = {
  isLoading: false,
  client: null,
  portfolio: null,
  goals: [],
  selectedGoal: null,
  allocations: [],
  assets: {
    data: [],
    total_items: 0,
    total_pages: 0,
    page: 0,
    page_size: 0,
  },
  error: null,
};

const slice = createSlice({
  name: 'assetAllocator',
  initialState,
  reducers: {
    fetchGoals(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchGoalsSuccess(state, action: PayloadAction<GoalData[]>) {
      state.goals = action.payload;
      state.isLoading = false;
    },
    fetchGoalsFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchAllocations(state, action: PayloadAction<string>) {
      state.isLoading = true;
      state.error = null;
    },
    fetchAllocationsSuccess(state, action: PayloadAction<AssetAllocation[]>) {
      state.allocations = action.payload;
      state.isLoading = false;
    },
    fetchAllocationsFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setSelectedGoal(state, action: PayloadAction<GoalData>) {
      state.selectedGoal = action.payload;
    },
    fetchAssets(state, action: PayloadAction<string>) {
      state.isLoading = true;
      state.error = null;
    },
    fetchAssetsSuccess(state, action: PayloadAction<AssetResponse>) {
      state.assets = action.payload;
      state.isLoading = false;
    },
    fetchAssetsFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { actions: assetAllocatorActions } = slice;

export const useAssetAllocatorSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: watchAssetAllocatorSaga });
  return { actions: slice.actions };
};
